import { useDreamSearchFilterContext } from "@portal/app/health/_components/components/filter/DreamSearchFilterContext";
import { faPeopleArrows } from "@fortawesome/pro-duotone-svg-icons/faPeopleArrows";
import { useState } from "react";
import { useDreamSearchContext } from "@portal/app/health/_components/DreamSearchContext";
import { FilterPill } from "./OnlineClassesFilterPill";
import { useMixpanel } from "@portal/app/_components/hooks/useMixpanel";

export const DirectPatientCareFilterPill = () => {
  const analytics = useMixpanel();
  const { filterSettings } = useDreamSearchContext();
  const { filters, setFilters } = useDreamSearchFilterContext();
  const [isActive, setIsActive] = useState(
    !!filters["program_vocation_subindustries_in"]?.includes("HEALTH_DIRECT_PATIENT_CARE")
  );

  return filterSettings?.subindustries.includes("HEALTH_DIRECT_PATIENT_CARE") ? (
    <FilterPill
      onClick={() => {
        setIsActive(!isActive);
        if (!isActive) {
          void analytics.track("Dream Search - Filter", {
            featured: "Direct patient care",
            filterGroup: "program_vocation_subindustries_in",
            filterItem: "HEALTH_DIRECT_PATIENT_CARE",
            filters,
          });
        }
        return setFilters(({ program_vocation_subindustries_in, ...prevFilters }) => ({
          ...prevFilters,
          program_vocation_subindustries_in: isActive ? [] : ["HEALTH_DIRECT_PATIENT_CARE"],
        }));
      }}
      isActive={isActive}
      title="Direct patient care"
      iconProps={{
        icon: faPeopleArrows,
        color: isActive ? "#04299E" : "#04299E70",
      }}
      data-testid="dream-search-filter-direct-patient-care"
    />
  ) : null;
};
